import {
  assignStopFailedNotification, assignStopSuccessNotification,
  getAssigningStopMessageKey,
} from '../../../../notifications/scheduling/assignStop';
import { ProjectRouteStopScheduledDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import getAppRoot from '../../utils/getAppRoot';

enum OptimizeResponseStatus {
  COMPLETE = 'complete',
  FAILED = 'failed',
}

const projectRouteStopScheduledHandler = ({
  store, pendingSolution, status,
}: ProjectRouteStopScheduledDtoModelType) => {
  if (pendingSolution.assignAction.visitId != null && pendingSolution.assignAction.targetRouteId != null) {
    const appEnv = getAppEnv(store);
    const appStore = getAppRoot(store);
    const id = String(pendingSolution.assignAction.visitId);
    const routeId = String(pendingSolution.assignAction.targetRouteId);
    const routeName = pendingSolution.assignAction.targetRouteName;
    const { visitName } = pendingSolution.assignAction;

    appEnv.closeMessage(getAssigningStopMessageKey(id));

    if (status === OptimizeResponseStatus.FAILED) {
      appEnv.notification(assignStopFailedNotification(id, visitName, routeName));
    } else {
      appEnv.notification(assignStopSuccessNotification(id, visitName, routeName, () => {
        appStore.ui.selectVisit(id);
        appStore.ui.selectRoute(routeId);
      }));
    }
  }

  return () => {
    store.assignActionStatusDtos.delete(pendingSolution.assignAction.id);
    store.solutionStatusOnlyDtos.delete(pendingSolution.id);
  };
};

export default projectRouteStopScheduledHandler;
